import request from "@/utils/request";
/* 参数说明
return request({
  url: "", // 接口路径
  method: "", // 请求方式
  data: "", // 数据添加在 body
  params: "", // 数据添加在 url 上
  ignoreToken: true // 是否忽略 token, true 忽略 、false 不忽略, 默认为 false
});
*/

// 手机登录
export function login(data) {
  return request({
    url: "/api-uaa/oauth/user/code/token",
    method: "post",
    data
  });
}
// 账户登录
// export function loginID(data) {
//   return request({
//     url: "/api-uaa/oauth/user/ums/token",
//     method: "post",
//     data
//   });
// }
// 总登录接口
export function loginID(data) {
  return request({
    url: "/api-userSystem/user/systemCheck/login",
    method: "post",
    data,
    baseURL: process.env.BASE_API_LOGIN
  });
}
// 智慧园区跳转过来调用
export function loginPhone(data) {
  return request({
    url: "/api-uaa/oauth/user/reg/token/phone2",
    method: "post",
    data
  });
}

// 数字孚生跳转过来调用
export function phoneTwin(data) {
  return request({
    url: "/api-uaa/oauth/user/reg/token/phoneTwin",
    method: "post",
    data
  });
}

// 判断商家是否入驻
export function IsStore(data) {
  return request({
    url: "/api-user/sys/SysStore/jumpIn",
    method: "post",
    data
  });
}
// 获取登录code
export function loginCode() {
  return request({
    url: "/loginCode",
    method: "get"
  });
}

// 注册
export function register(data) {
  return request({
    url: "/api-uaa/oauth/user/reg/token/phone",
    method: "post",
    data
  });
}

//获取注册页面--手机短信验证码
export function getPhoneCode(params) {
  return request({
    url: "/api-member/applet/send/sms/codes",
    method: "post",
    params: params
  });
}

// 获取登录页面--手机短信验证码
export function getPhoneCodeLogin(params) {
  return request({
    url: "/api-member/applet/send/sms/codesLogin",
    method: "post",
    params: params
  });
}

// 获取用户信息
export function userinfo() {
  return request({
    url: "/api-uaa/oauth/member/memberinfo",
    method: "get"
  });
}

// 退出登录
export function logout(params) {
  return request({
    url: `/api-uaa/oauth/remove/tokens?access_token=${params}`,
    method: "post",
    params: params
  });
}

// 全部商品分类
export function getGoodsType() {
  return request({
    url: "/api-goods/PcNotAuth/list/withChildren",
    method: "get",
    ignoreToken: true
  });
}

// 全部商品分类2
export function withChildrenPerfect() {
  return request({
    url: "/api-goods/pms/PmsProductCategory/list/withChildrenPerfect",
    method: "get"
  });
}

// 获取城市列表
export function citylist() {
  return request({
    url: "/citylist",
    method: "get"
  });
}

// 推荐栏目  精选=>handpickStatus=1  爆款=>faddishStatus=1
export function recommendList(params) {
  return request({
    url: "/api-goods/PcNotAuth/list/typeProductList",
    method: "get",
    params: params,
    ignoreToken: true
  });
}

// 搜索内容列表
export function searchContent(params) {
  return request({
    url: "/api-answer/open/searchContent",
    method: "get",
    params
  });
}

// 获取联系方式
export function getContactInfoByContactNum(params) {
  return request({
    url: "/api-answer/open/getContactInfoByContactNum",
    method: "get",
    params
  });
}

// 发布问题
export function publishIssue(data) {
  return request({
    url: "/api-answer/question/publish",
    method: "post",
    data
  });
}

// 大库存
export function recommendStore(params) {
  return request({
    url: "/api-goods/PcNotAuth/list/typeProductList",
    method: "get",
    params: params,
    ignoreToken: true
  });
}

// 商品列表
export function goodsFindList(params) {
  return request({
    url: "/api-goods/PcNotAuth/list/listWithProduct",
    method: "get",
    params: params
  });
}

// 商品类目
export function goodsTypeList(params) {
  return request({
    url: "/api-goods/PcNotAuth/list/withChildrenCategory",
    method: "get",
    params: params
  });
}

// 商品详情http://192.168.1.18:8081/api-goods/notAuth/goods/detail?id=4&memberId=1
export function goodsDetailList(params) {
  return request({
    url: "/api-goods/PcNotAuth/goods/detail",
    method: "get",
    params: params
  });
}

// 同类商品
export function categoryDetailList(params) {
  return request({
    url: "/api-goods/PcNotAuth/category/detail",
    method: "get",
    params: params
  });
}
// 发帖
export function saveForumInfo(data) {
  return request({
    url: "/api-forum/forum/forumInfo/saveForumInfo",
    method: "post",
    data
  });
}
// 优质问答&&热门问答&&最新问答
export function findForumInfoResult(params) {
  return request({
    url: "/api-forum/forum/forumInfo/findForumInfoResult",
    method: "get",
    params: params
  });
}

// 获取当前帖子所有信息
export function findAllCommentReply(params) {
  return request({
    url: "/api-forum/forum/forumInfo/findAllCommentReply",
    method: "get",
    params: params
  });
}

// 浏览记录+1
export function addNumberViews(params) {
  return request({
    url: "/api-forum/forum/forumInfo/addNumberViews",
    method: "post",
    params: params
  });
}

// 问答专家
export function findAnswerExperts() {
  return request({
    url: "/api-forum/forum/forumInfo/findAnswerExperts",
    method: "get"
  });
}

// 本周活跃用户
export function findAnswerExpertsOfWeek() {
  return request({
    url: "/api-forum/forum/forumInfo/findAnswerExpertsOfWeek",
    method: "get"
  });
}
// 回复帖子
export function saveForumComment(data) {
  return request({
    url: "/api-forum/forum/forumInfo/saveForumComment",
    method: "post",
    data
  });
}

// 回复评论
export function saveForumCommentReply(data) {
  return request({
    url: "/api-forum/forum/forumInfo/saveForumCommentReply",
    method: "post",
    data
  });
}

// 点赞
export function saveForumLike(data) {
  return request({
    url: "/api-forum/forum/forumInfo/saveForumLike",
    method: "post",
    data
  });
}

// 图片地址
export function uploadPic(data) {
  return request({
    url: "/api-file/files-anon",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

// 获取上传的图片
export function findAllInfoFileByComments(params) {
  return request({
    url: "/api-forum/forum/forumInfo/findAllInfoFileByComments",
    method: "get",
    params: params
  });
}

// 查询收货地址信息
export function listAddress() {
  return request({
    url: "/api-order/PcAuth/listAddress",
    method: "get"
  });
}

// 添加/修改收货地址
export function saveAddress(params) {
  return request({
    url: "/api-order/PcAuth/saveAddress",
    method: "get",
    params: params
  });
}
// 删除收货地址
export function deleteAddress(params) {
  return request({
    url: "/api-order/PcAuth/deleteAddress",
    method: "get",
    params: params
  });
}

// 设为默认收货地址
export function defaultAddress(params) {
  return request({
    url: "/api-order/PcAuth/address-set-default",
    method: "get",
    params: params
  });
}

// 获取默认收货地址
export function getItemDefautl() {
  return request({
    url: "/api-order/PcAuth/getItemDefautl",
    method: "get"
  });
}

// 添加/修改发票资料
export function saveInvoiceRecord(params) {
  return request({
    url: "/api-order/PcAuth/saveInvoiceRecord",
    method: "get",
    params: params
  });
}

// 显示发票资料
export function listInvoiceRecord(params) {
  return request({
    url: "/api-order/PcAuth/listInvoiceRecord",
    method: "get",
    params
  });
}

// 删除发票资料
export function deleteInvoiceRecord(params) {
  return request({
    url: "/api-order/PcAuth/deleteInvoiceRecord",
    method: "get",
    params: params
  });
}

// 显示所有发票订单
export function saveInvoiceRecordOrder(params) {
  return request({
    url: "/api-order/PcAuth/listInvoiceRecordOrder",
    method: "get",
    params: params
  });
}

// 订单提交
export function generateOrder(data) {
  return request({
    url: "/api-order/PcAuth/create",
    method: "post",
    data
  });
}

// 物流
export function listCompany() {
  return request({
    url: "/api-goods/pms/PmsFeightTemplate/list",
    method: "get"
  });
}

// 购物车列表
export function shoppingCarList() {
  return request({
    url: "/api-order/OmsCartItem/OmsCartItemResult",
    method: "get"
  });
}

// 添加商品到购物车
export function addToShoppingCar(data) {
  return request({
    url: "/api-order/OmsCartItem/addOmsCartItem",
    method: "post",
    data
  });
}

// 删除购物车
export function delCurShoppingCar(data) {
  return request({
    url: "/api-order/OmsCartItem/deleteOmsCartItemById",
    method: "post",
    data
  });
}

// 修改购物车数量
export function changeShoppingCarNum(data) {
  return request({
    url: "/api-order/OmsCartItem/uddateOmsCartItem",
    method: "post",
    data
  });
}

// 添加到购物车数量
export function shoppingCarNum() {
  return request({
    url: "/api-order/OmsCartItem/OmsCartItemNum",
    method: "get"
  });
}

// 资讯
export function findInformationDisplayResult(params) {
  return request({
    url:
      "api-forum/open/forum/forumInformationDisplay/findInformationDisplayResult",
    method: "get",
    params: params
  });
}
// 修改账户信息
export function updateUmsMember(data) {
  return request({
    url: "/api-uaa/oauth/member/updateUmsMember",
    method: "post",
    data
  });
}

// 修改手机下一步验证
export function testMemberPhone(data) {
  return request({
    url: "/api-uaa/oauth/member/testMemberPhone",
    method: "post",
    data
  });
}

// 修改手机提交
export function updateUmsMemberPhone(data) {
  return request({
    url: "/api-uaa/oauth/member/updateUmsMemberPhone",
    method: "post",
    data
  });
}

// 修改密码
export function updatePassWord(params) {
  return request({
    url: "/api-uaa/oauth/member/updatePassWord",
    method: "get",
    params: params
  });
}

// 咨询类别
export function findconsultingCategoryCode() {
  return request({
    url: "api-forum/forum/forumConsultingService/findconsultingCategoryCode",
    method: "get"
  });
}

//咨询问题
export function findConsultingServiceCode() {
  return request({
    url: "api-forum/forum/forumConsultingService/findConsultingServiceCode",
    method: "get"
  });
}

// 咨询提交
export function addConsultingService(data) {
  return request({
    url: "api-forum/forum/forumConsultingService/addConsultingService",
    method: "post",
    data
  });
}

// 投诉提交
export function addForumComplaintCenter(data) {
  return request({
    url: "api-forum/forum/forumComplaintCenter/addForumComplaintCenter",
    method: "post",
    data
  });
}

// 咨询列表
export function ConsultingServiceResult(data) {
  return request({
    url: "api-forum/forum/forumConsultingService/ConsultingServiceResult",
    method: "post",
    data
  });
}

// 投诉列表
export function ComplaintCenterResult(data) {
  return request({
    url: "api-forum/forum/forumComplaintCenter/ConsultingServiceResult",
    method: "post",
    data
  });
}

// 我的提问内容列表
export function getAskContentList(params) {
  return request({
    url: "/api-answer/home/myQuestionDefaultList",
    method: "get",
    params
  });
}

// 投诉处理方式
export function findComplaintCenterCode() {
  return request({
    url: "api-forum/forum/forumComplaintCenter/findComplaintCenterCode",
    method: "get"
  });
}

// 轮播图   carouselArea  1=>首页  2=>仓储
export function findRotationChart(params) {
  return request({
    url: "api-goods/open/goods/RotationChart/findRotationChart",
    method: "get",
    params: params
  });
}

// 城市列表
export function cityListTree() {
  return request({
    url: "/api-order/auth/city/list/tree",
    method: "get"
  });
}

// 物流价格信息
export function fetchwlinfo(data) {
  return request({
    url: "/api-order/auth/templates/getList",
    method: "get",
    params: data
  });
}

// 查询预下单
export function searchOrder(data) {
  return request({
    url: "/api-order/PcAuth/pre/order",
    method: "post",
    data
  });
}

// 加载预下单
export function searchPre(params) {
  return request({
    url: "/api-order/PcAuth/load/pre/" + params,
    method: "get"
  });
}

// 站内信列表
export function findStationMessageResult(data) {
  return request({
    url: "/api-forum/forum/stationMessage/findStationMessageResult",
    method: "post",
    data
  });
}

// 标记已读
export function updateStationMessage(data) {
  return request({
    url: "/api-forum/forum/stationMessage/updateStationMessage",
    method: "post",
    data
  });
}

// 批量删除
export function deleteStationMessage(data) {
  return request({
    url: "/api-forum/forum/stationMessage/deleteStationMessage",
    method: "post",
    data
  });
}

// 优惠券
export function hasYouHuiQuan(params) {
  return request({
    url: "/api-goods/PcAuth/coupons/order/" + params,
    method: "get"
  });
}

// 优惠券列表 useType=1
export function couponList(params) {
  return request({
    url: "/api-goods/auth/coupon/list",
    method: "get",
    params
  });
}

// 优惠券领取  couponId=2
export function receiveYHJ(params) {
  return request({
    url: "/api-goods/PcAuth/coupon/receive",
    method: "post",
    params
  });
}

// 运费获取
export function getPrice(data) {
  return request({
    url: "/api-order/PcAuth/computed/price",
    method: "post",
    data
  });
}

// 会员中心查询订单
export function myorderlist(params) {
  return request({
    url: "/api-order/PcAuth/member/order/list",
    method: "get",
    params
  });
}

// 会员中心订单头部
export function myorderdata(params) {
  return request({
    url: "/api-order/PcAuth/member/order/data",
    method: "get",
    params
  });
}

// 订单详情
export function orderDetail(params) {
  return request({
    url: "/api-order/PcAuth/order/detail/" + params,
    method: "get"
  });
}

// 采购添加
export function addPurchaseRequisition(data) {
  return request({
    url: "/api-goods/forum/purchaseRequisition/addPurchaseRequisition",
    method: "post",
    data
  });
}

// 需求列表
export function purchaseRequisitionResults(data) {
  return request({
    url: "/api-goods/forum/purchaseRequisition/purchaseRequisitionResults",
    method: "post",
    data
  });
}

// 商户入驻判断
export function checkUserCreate(data) {
  return request({
    url: "/api-userSystem/user/systemCheck/IsSettleIn",
    method: "post",
    data
  });
}

// 获取商家中心token
export function oneUserToken(data) {
  return request({
    url: "/api-userSystem/user/systemCheck/loginByPhone",
    method: "post",
    data,
    baseURL: process.env.BASE_API_LOGIN
  });
}

// 商户入驻申请
export function userCreate(data) {
  return request({
    url: "/api-user/sysStoreAudit/create",
    method: "post",
    data
  });
}

// 货到付款 选择支付渠道
export function payType(data) {
  return request({
    url: "/api-order/PcAuth/or/update/payType",
    method: "post",
    data
  });
}

// 取消订单
export function cancelOrder(id) {
  return request({
    url: "/api-order/PcAuth/cancel?id=" + id,
    method: "post"
  });
}

// 查看发货时间
export function selectTime(params) {
  return request({
    url: "/api-order/PcAuth/or/member/selectTime",
    method: "get",
    params
  });
}

// 查看银行卡信息
export function selectBank(params) {
  return request({
    url: "/api-order/PcAuth/bank/selectBank",
    method: "get",
    params
  });
}

// 上传凭证
export function payment(params) {
  return request({
    url: "/api-order/PcAuth/or/member/update/payment",
    method: "get",
    params
  });
}

// 上传
export function policy(data) {
  return request({
    url: "/api-file/files-anon",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

// 查看物流
export function selectSend(params) {
  return request({
    url: "/api-order/auth/shop/selectSend",
    method: "get",
    params
  });
}

// 收货
export function getSomething(params) {
  return request({
    url: "/api-order/auth/shop/confirm",
    method: "get",
    params
  });
}
// 校验手机号和验证码
export function checkSimpleRegPhone(data) {
  return request({
    url: "/api-uaa/oauth/user/reg/token/checkSimpleRegPhone",
    method: "post",
    data
  });
}

// 校验手机号和验证码
export function updateSysUserPassWord(data) {
  return request({
    url: "/api-user/users-anon/updateSysUserPassWord",
    method: "post",
    data
  });
}

//   做测试  /oauth/mobile/token



// WEBPACK FOOTER //
// ./src/api/user.js